import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

// 定义接口
import servicePlugin from './services/servicePlugin.js'
Vue.use(servicePlugin)

// 引入全局css样式
import './assets/commonCss.less'

// 引入移动端适配
import './assets/js/initMobile'

// 引入vant-ui
import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

// 引入全局公共方法
import publicFunction from './assets/js/publicFunction'
Vue.prototype.pub_fun = publicFunction

// 引入全局js变量
import commonVariable from './assets/js/commonVariable'
Vue.use(commonVariable)

import { Loading } from 'element-ui';
Vue.use(Loading.directive);



new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
